<script>
	import { onMount } from 'svelte';
	import { 
		differenceInDays,
		differenceInSeconds, 
		differenceInMinutes,
		differenceInHours,
		formatDuration,
		nextDay, 
		isFriday,
		set,
		format
	} from 'date-fns'
	
	let time = new Date();
	
	$: itIsFriday = isFriday(time);
	$: nextFriday = nextDay(set(time, { hours: 0, minutes: 0, seconds: 0 }), 5);
	$: daysDiff = -differenceInDays(time, nextFriday);
	$: hoursDiff = -differenceInHours(time, nextFriday) - daysDiff * 24;
	$: minutesDiff = -differenceInMinutes(time, nextFriday) - daysDiff * 24 * 60 - hoursDiff * 60;
	$: secondsDiff = -differenceInSeconds(time, nextFriday) - daysDiff * 24 * 60 * 60 - hoursDiff * 60 * 60 - minutesDiff * 60;
	$: formatted = formatDuration({ days: daysDiff, hours: hoursDiff, minutes: minutesDiff, seconds: secondsDiff })
	
	onMount(async () => {
		const interval = setInterval(() => {
			time = new Date();
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	});
</script>

<style>
	
</style>

<h1>
	Is it Friday yet?
</h1>

{#if itIsFriday}
	<h2>
		Yup, it's Friday!!
	</h2>
{:else}
	<p>
		No, but it will be in: {formatted}
	</p>
{/if}